/**
 * ステップの切り替え処理を行う
 */
 $(function () {
    
    // ステップの切り替え時
    $(document).on('click', '.step-trigger', function() {
        bs_step_trigger(this);
    });
});